var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{style:({ height: '240px', width: '1040px' }),attrs:{"id":_vm.chartId,"height":"240","width":"1040"}})}
var staticRenderFns = []

export { render, staticRenderFns }